module.exports = "/assets/data/092d82d393a3bb6fe8a1fff93df01e35-NG90.data.json";